export const USER_LOGGED_IN = 'user/LOGGED_IN';
export const USER_LOGGED_OUT = 'user/LOGGED_OUT';
export const USER_AUTHORIZATION_DONE = 'user/USER_AUTHORIZATION_DONE';
